module.exports = __webpack_public_path__ + "static/portfolio-mas-4-9ea1e016858e6920886e3187aa3eaf84.jpg";